'use client'

import { useTranslations } from 'next-intl'
import { ClipboardList } from 'lucide-react'
import { VideoButton } from './VideoButton'
import { ScreenshotZoom } from './ScreenshotZoom'

// Radio button SVGs from the app - commented out for now
// function RadioSelected() {
//   return (
//     <svg width="24" height="24" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
//       <mask id="radio-selected" fill="white">
//         <path d="M0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13Z"/>
//       </mask>
//       <path d="M13 26V24C6.92487 24 2 19.0751 2 13H0H-2C-2 21.2843 4.71573 28 13 28V26ZM26 13H24C24 19.0751 19.0751 24 13 24V26V28C21.2843 28 28 21.2843 28 13H26ZM13 0V2C19.0751 2 24 6.92487 24 13H26H28C28 4.71573 21.2843 -2 13 -2V0ZM13 0V-2C4.71573 -2 -2 4.71573 -2 13H0H2C2 6.92487 6.92487 2 13 2V0Z" fill="currentColor" mask="url(#radio-selected)"/>
//       <circle cx="13" cy="13" r="7" fill="currentColor"/>
//     </svg>
//   )
// }

// function RadioUnselected() {
//   return (
//     <svg width="24" height="24" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
//       <mask id="radio-unselected" fill="white">
//         <path d="M0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13Z"/>
//       </mask>
//       <path d="M13 26V24C6.92487 24 2 19.0751 2 13H0H-2C-2 21.2843 4.71573 28 13 28V26ZM26 13H24C24 19.0751 19.0751 24 13 24V26V28C21.2843 28 28 21.2843 28 13H26ZM13 0V2C19.0751 2 24 6.92487 24 13H26H28C28 4.71573 21.2843 -2 13 -2V0ZM13 0V-2C4.71573 -2 -2 4.71573 -2 13H0H2C2 6.92487 6.92487 2 13 2V0Z" fill="currentColor" mask="url(#radio-unselected)"/>
//     </svg>
//   )
// }

interface FeatureAgendaProps {
  hideVideoButton?: boolean
}

export function FeatureAgenda({ hideVideoButton }: FeatureAgendaProps = {}) {
  const t = useTranslations('features.agenda')
  return (
    <div className="flex flex-wrap gap-[16px] items-start">
      {/* Phone screenshot (clickable) */}
      <ScreenshotZoom src="/images/feature-agenda.png" alt={t('imageAlt')} />

      {/* Content */}
      <div className="flex flex-col gap-[6px] flex-1 min-w-0 break-words hyphens-auto">
        {/* Icon */}
        <div className="w-[24px] h-[24px]">
          <ClipboardList size={24} strokeWidth={2} className="text-[#6B8E6B]" />
        </div>

        {/* Text */}
        <div className="flex flex-col gap-[4px] pt-[2px]">
          <p className="text-xl font-bold">{t('title')}</p>
          <p className="text-l">
            {t('desc')}
          </p>
        </div>

        {/* Video button */}
        {!hideVideoButton && <VideoButton videoId="agenda" className="mt-[8px]" />}

        {/* Zoom button */}

        {/* Radio group - commented out for now */}
        {/* <div className="flex flex-col">
          <button
            onClick={() => setMode('simple')}
            className="flex items-center gap-[10px] h-[44px] cursor-pointer"
          >
            {mode === 'simple' ? <RadioSelected /> : <RadioUnselected />}
            <span className="text-l">Simple</span>
          </button>

          <button
            onClick={() => setMode('detailed')}
            className="flex items-center gap-[10px] h-[44px] cursor-pointer"
          >
            {mode === 'detailed' ? <RadioSelected /> : <RadioUnselected />}
            <span className="text-l">Detailed</span>
          </button>
        </div> */}
      </div>
    </div>
  )
}
